import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface UseViewStatementsStore {
  loading: boolean;
  data: string;
  error: string | null;
  viewStatement: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useViewStatementsStore = create<UseViewStatementsStore>((set, get) => ({
  loading: false,
  data: '',
  error: null,

  viewStatement: async (cardId, signal) => {
    try {
      set({ loading: true, data: '', error: null });
      const result = await CardsApi.downloadStatements(cardId, signal);
      set({ loading: false, data: URL.createObjectURL(result.data) });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => {
    URL.revokeObjectURL(get().data);
    set({ loading: false, data: '', error: null });
  },
}));
